var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileBrowseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 48,
    viewBox: "0 0 59 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0364 40C47.7949 40 54.0834 34.944 54.0834 28.706C54.0834 23.762 50.1328 19.56 44.6311 18.03C43.8493 12.388 37.8952 8 30.6702 8C22.9117 8 16.6233 13.056 16.6233 19.294C16.6233 20.674 16.9306 21.994 17.4935 23.218C16.8212 23.1116 16.138 23.0581 15.4531 23.058C9.63423 23.06 4.91669 26.852 4.91669 31.53C4.91669 36.208 9.63423 40 15.4531 40H40.0364Z",
    fill: "#F4B652"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4358 5.90977C21.8985 4.40662 18.7504 3.75012 15.6371 4.07489C12.5238 4.39965 9.68122 5.68107 7.69209 7.6564C5.70296 9.63173 4.71805 12.1513 4.93928 14.6985C5.16052 17.2458 6.57115 19.6276 8.88194 21.3558C10.1674 20.8147 11.5468 20.4363 12.9726 20.2338C12.9477 19.9208 12.9354 19.6073 12.9357 19.2938C12.9357 13.1478 17.7319 7.93977 24.4358 5.90977Z",
    fill: "#F4B652"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileBrowseIcon);
export default __webpack_public_path__ + "static/media/file_browse_icon.074bb2d856d4088ef8517d0bb481fa49.svg";
export { ForwardRef as ReactComponent };